const API_BASE = "/api";

export const getAuthHeaders = (): Record<string, string> => {
  const token = localStorage.getItem("bearer_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const handleJson = async <T>(response: Response): Promise<T> => {
  if (!response.ok) {
    const raw = await response.text();
    throw new Error(raw || response.statusText);
  }
  const text = await response.text();
  if (!text.trim()) {
    return undefined as unknown as T;
  }
  return JSON.parse(text) as T;
};

export const apiBase = API_BASE;
